export default __webpack_public_path__ + "static/media/04 Personal Details – 1@2x.37d5a6c9.png";